import * as z from "../../../vendor/zod/src/index";
export default z.object({
    trader_configuration_id: z.number().int(),
});
